import type { ReactNode } from 'react';
interface ConditionProps {
  expression: boolean;
  then: ReactNode;
  else?: ReactNode;
}
export const Condition = ({
  expression,
  then,
  else: elseNode
}: ConditionProps) => {
  return expression ? then : elseNode;
};